import { colors } from '../theme/colors';

// TypeScript utility type to extract all valid CSS variable paths from the colors object
type DeepPaths<T, K extends keyof T = keyof T> = K extends string
    ? T[K] extends Record<string, any>
        ? T[K] extends string
            ? K
            : `${K}.${DeepPaths<T[K]>}`
        : K
    : never;

// Extract all valid CSS variable paths from the colors object
export type ValidCSSVariablePath = DeepPaths<typeof colors>;

export function getCSSVar(path: ValidCSSVariablePath): string {
    const variableName = `--${path.replace(/\./g, '-')}`;
    return `var(${variableName})`;
}
